import i18n from "@/i18n";

export default {
  headers: [
    {
      text: i18n.t("crudCategories.hName"),
      value: "name",
      sortable: true,
    },
    {
      text: i18n.t("crudCategories.hIcon"),
      value: "iconRepresentation",
      align: "center",
      sortable: true,
    },
    {
      text: i18n.t("crudRooms.hActions"),
      value: "actions",
      align: "center",
      sortable: false,
    },
  ],
  locale: {
    title: i18n.t("crudCategories.title"),
    search: i18n.t("crudCategories.search"),
    deleteConfirm: i18n.t("crudCategories.deleteConfirm"),
    newItem: i18n.t("crudCategories.newCategory"),
    updateItem: i18n.t("crudCategories.updateCategory"),
  },
};
